import { useEffect, useRef, useState } from "react"
import { FirePerimeterManualKeyboardShortcuts } from "plugins/DrawPerimeter/plugin-actions/methods/manual/FirePerimeterManualKeyboardShortcuts"
import { geometryDataStore } from "plugins/shared/layers/GeometryDataStore"
import { useEffectUnsafe } from "@nova/use-effect-unsafe"
import { FirePerimeterMethod, ToolName } from "@nova/constants"
import {
    createNewMockedPerimeter,
    createNewMockedPolygon,
    selectEditingFirePerimeterId,
    selectUpdateMethod,
    updatePerimeterCanConfirm,
} from "plugins/DrawPerimeter/FirePerimeterSlice"
import { selectActiveToolName, setActiveTool } from "plugins/Toolbox/tool-registry"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"

export const InspectorPanelFirePerimeterUpdateManual = ({ onBlur }: { onBlur: () => void }) => {
    const dispatch = useAppDispatch()
    const activeTool = useAppSelector(selectActiveToolName())
    const activeToolRef = useRef<ToolName>(undefined)
    const perimeterId = useAppSelector(selectEditingFirePerimeterId())
    const newPerimeter = !perimeterId
    const updateMethod = useAppSelector(selectUpdateMethod())

    const [shortcutsIsOpen, setShortcutsIsOpen] = useState(false)
    useEffect(() => {
        const onClosed = () => onBlur()
        geometryDataStore.on("closed", onClosed)
        return () => {
            geometryDataStore.off("closed", onClosed)
        }
    }, [onBlur])

    useEffectUnsafe(() => {
        if (updateMethod !== FirePerimeterMethod.Manual) return
        if (newPerimeter) dispatch(createNewMockedPerimeter())
        else {
            geometryDataStore.free(true)
            dispatch(createNewMockedPolygon())
        }

        dispatch(setActiveTool(ToolName.FirePerimeter))
    }, [updateMethod])

    // Blur this hook's parent component when the active tool changes from FP to none.
    useEffectUnsafe(() => {
        if (!activeTool && activeToolRef.current === ToolName.FirePerimeter) {
            onBlur?.()
        }
        activeToolRef.current = activeTool
    }, [activeTool])

    const points = geometryDataStore.useGeometryData("points")
    const canConfirm = points.length >= 3

    useEffect(() => {
        dispatch(updatePerimeterCanConfirm(canConfirm))
    }, [canConfirm, dispatch])

    return (
        <div className="py-2">
            <FirePerimeterManualKeyboardShortcuts
                isOpen={shortcutsIsOpen}
                setIsOpen={(isOpen) => setShortcutsIsOpen(isOpen)}
            />
        </div>
    )
}
